
import "./GameCard.css";
import { FiClock } from "react-icons/fi";
import { LuGamepad2 } from "react-icons/lu";



export default function GameCard({ title, number, openTime, closeTime, closed, isAccountActive, statusText, onTimeClick }) {
  const handleClockClick = (e) => {
    e.stopPropagation();           // ⬅️ prevent parent card click
    onTimeClick && onTimeClick();  // ⬅️ open the time modal
  };

  return (
    <div className={`game-card ${!isAccountActive ? 'disabled' : ''}`}>
      <div className="card-header">
        <h3 className="game-title">{title}</h3>
        {isAccountActive && (
          <button type="button" className="time-icon-button" onClick={handleClockClick}>
            {/* <MdAccessTimeFilled size={22} color="#140b5c" /> */}
            < FiClock size={20} color="#080459" />
          </button>
        )}
      </div>

      <div className="card-body1">
        <p className="game-number">{number}</p>
        <p className="betting-time">
          Bet - {openTime} - {closeTime}
        </p>
        <span className={`game-status ${closed ? "closed" : "open"}`}>
          {statusText}
        </span>
      </div>

      <div className="card-footer">
        {isAccountActive && (
          <button className="play-button">
            <LuGamepad2 size={22} />
            <span>Play Game</span>
          </button>
        )}
      </div>
    </div>
  );
}